import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-coverage-accordion-header',
  templateUrl: './coverage-accordion-header.component.html',
  standalone: false,
})
export class CoverageAccordionHeaderComponent {
  @Input() open = false;
  @Input() minimize = false;
  @Input() select = false;
  @Input() checkbox = false;
  @Input() disabled = false;
  @Input() header = 'Coverage';

  @Output() selected = new EventEmitter<boolean>();
  @Output() toggled = new EventEmitter<boolean>();

  protected toggle() {
    this.open = !this.open;
    this.toggled.emit(this.open);
  }
}
